import { TransformUnknownKindError } from './TransformUnknownKindError';
import {
  applyTransformStep,
  isKnownTransformStepKind,
} from './transformRegistry';
import type {
  ApplyTransformStepsResult,
  TransformRow,
  TransformStep,
} from './types';

/**
 * Run an ordered list of declarable transform steps over query rows.
 * Unknown kinds return a typed error without throwing; missing columns
 * on a step skip that step and emit a warning.
 */
export function applyTransformSteps(
  rows: TransformRow[],
  steps: readonly TransformStep[],
): ApplyTransformStepsResult {
  if (rows.length === 0) {
    return { rows: [], warnings: [] };
  }

  let current = rows;
  const warnings: string[] = [];

  for (const step of steps) {
    if (!isKnownTransformStepKind(step.kind)) {
      return {
        rows: current,
        warnings,
        error: new TransformUnknownKindError(String(step.kind)),
      };
    }

    const result = applyTransformStep(current, step);
    current = result.rows;
    warnings.push(...result.warnings);
  }

  return { rows: current, warnings };
}
